import { render, staticRenderFns } from "./Academica.vue?vue&type=template&id=100f2232&"
import script from "./Academica.vue?vue&type=script&lang=js&"
export * from "./Academica.vue?vue&type=script&lang=js&"
import style0 from "./Academica.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports